import { Portal } from '../enums/portal.enum';

const COUNTRY_TO_PORTAL_MAP: Record<string, Portal> = {
  PH: Portal.PHILIPPINES,
  US: Portal.USA,
  // Add future countries
};

export function getPortalFromCountry(countryCode?: string): Portal | undefined {
  if (!countryCode) return undefined;

  const normalizedCode = countryCode.toUpperCase();
  return COUNTRY_TO_PORTAL_MAP[normalizedCode] || Portal.PHILIPPINES;
}

export const SidebarLabel = {
  [Portal.PHILIPPINES]: 'Philippine',
  [Portal.USA]: 'USA',
  [Portal.INTERNATIONAL]: 'International',
  [Portal.DEFAULT]: 'Global',
};
